import React from 'react'
import { useSelector } from "react-redux";
import { selectAllUsers } from './usersSlice';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


function Participants() {
  const users = useSelector(selectAllUsers);
  const participants = users.filter((user) => user.status_id === 4)
  console.log(participants)
    const renderedParticipants = participants.map((user) => (
      <Col xs={12} sm={12} md={6} lg={6} xl={6} key={`participant-${user.id}`}>
        <Row className="row">
        
        <Col xs={4} sm={4} md={4} xl={4} className="text-center" id="speaker-img-container">
          <img id="participantImg" className="w-100 h-50 align-middle mt-5" src={`${process.env.PUBLIC_URL}/${user.mainimageurl}`} alt="" />
          {/* <img id="participantImg" className="w-100 h-50 align-middle mt-5" src={process.env.PUBLIC_URL + '/' + user.mainimageurl} alt="" /> */}
        </Col>
        
        <Col xs={8} sm={8} md={8} xl={8}>
          <h3 className="bold">
            <Link to={`/users/${user.id}`}>{user.name}</Link> 
          </h3>
          
          <h6 className="my-text-red bold">
            {user.position}
          </h6>
          <hr />
          <p>
            {user.presentation}
          </p>
          <button className="btn my-bg-red small bold mb-5">Read more</button>
          <br />  
        </Col>    
      </Row>
    </Col>
  ))

  /* const renderedLocation = ParticipantsLocationFn.map((participant) => (
    <h3 className="bold">
      <Link to={`/participants/${participant.id}`}>{participant.name}</Link> 
    </h3>
  ));
 */
  const participantRows = [];
  for (let i = 0; i < renderedParticipants.length; i += 2) {
    participantRows.push(
      <Row key={i} className="row">
        {renderedParticipants[i]}
        {renderedParticipants[i + 1]}
      </Row>
    );
  }


  return (
    <section>
      <Container>
        {participantRows}
        {/* {ParticipantsLocationFn} */}
      </Container>
    </section>
  )
}

export default Participants